<template>
  <div class="action-button__wrapper">
    <div class="action-button__item view" @click="detail()">
      {{ $l('menu_label_view') || '查看' }}
    </div>
    <el-dropdown trigger="click" @command="command">
      <i class="el-icon-arrow-down action-button__item"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(opt, index) in opts"
          :key="index"
          :icon="opt.icon"
          :command="opt"
          :divided="opt.divided"
          :disabled="opt.disabled == undefined ? false : opt.disabled(item)"
        >
          {{ opt.text }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <InfoChange
      :visible.sync="infoChangeFormVisible"
      :custCode="item.custCode"
      @reload="$emit('reload')"
      @close="close"
    />
    <OrderChange
      :visible.sync="orderChangeFormVisible"
      :custCode="item.custCode"
      @reload="$emit('reload')"
      @close="close"
    />
    <BankChange
      :visible.sync="bankChangeFormVisible"
      :custCode="item.custCode"
      @reload="$emit('reload')"
      @close="close"
    />
  </div>
</template>

<script>
import actionOpts from './action-opts'
import EditLoading from '@/mixins/edit-loading'
import InfoChange from '../change/infoChange'
import OrderChange from '../change/orderChange'
import BankChange from '../change/bankChange'
export default {
  components: {
    InfoChange,
    OrderChange,
    BankChange,
  },
  mixins: [EditLoading],
  props: { item: { type: Object, default: () => ({}) } },
  computed: {
    opts() {
      const opts = actionOpts(this)
      return opts.filter((opt) => (!opt.allow ? true : this.allow(opt.allow)))
    },
  },
  data() {
    return {
      infoChangeFormVisible: false,
      orderChangeFormVisible: false,
      bankChangeFormVisible: false,
    }
  },
  methods: {
    detail() {
      const { custCode, custNo } = this.item
      this.$router.push({
        name: 'customerManage-myCust-detail',
        params: { custCode },
        query: { custNo },
      })
    },
    command({ menuType }) {
      switch (menuType) {
        case 'editV2':
          this.openEditPage(menuType)
          break
        case 'risk-assessment':
          this.riskAssessment()
          break
        case 'convertPotential':
          this.convertPotential()
          break
        case 'convertFormal':
          this.convertFormal()
          break
        case 'infoChange':
          this.infoChangeFormVisible = true
          break
        case 'orderChange':
          this.orderChangeFormVisible = true
          break
        case 'bankChange':
          this.bankChangeFormVisible = true
          break
      }
    },
    openEditPage(pageType) {
      const { custCode, custNo } = this.item
      this.$router.push({
        name: 'customerManage-info-v2-detail',
        params: { custCode, pageType },
        query: { custNo },
      })
    },
    async riskAssessment() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_riskAssessment') || '是否生成该客户风险核查单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .customerRiskCheckAddApi({ custCode: this.item.custCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_generate_ok') || '生成失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_generate_ok') || '生成成功！',
        type: 'success',
      })
    },
    async convertPotential() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_potential_customer') ||
          '是否提交转潜在客户申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerConvertPotentialApi({ custCode: this.item.custCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_submission_failed') || '提交失败！')
        return
      }
      this.$message({
        message: this.$l('tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async convertFormal() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_formal_customer') || '是否提交转正式客户申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerConvertFormalApi({ custCode: this.item.custCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_submission_failed') || '提交失败！')
        return
      }
      this.$message({
        message: this.$l('tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    close() {
      this.infoChangeFormVisible = false
      this.orderChangeFormVisible = false
      this.bankChangeFormVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.action-button__wrapper {
  display: flex;
  align-items: center;
  min-width: max-content;
}
.action-button__item {
  width: 30px !important;
  height: 30px !important;
  font-size: 18px !important;
  text-align: center;
  line-height: 30px !important;
  cursor: pointer;
  border-radius: 4px;
  background-color: #f8f8f8;
}
.action-button__item.view {
  width: 60px !important;
  font-size: 13px !important;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.el-icon-arrow-down.action-button__item {
  margin-left: 1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.action-button__item:hover {
  color: #007bff !important;
  background-color: #e7f1fe !important;
}
</style>
